import axios from "axios";
import ApiErrors from "../utilities/ApiErrors";

export default {

  async loginPDV(datos) {
    delete axios.defaults.headers.common["Authorization"];

    try {
      const { data } = await axios({
        url: `/auth/loginPDV`,
        data: datos,
        method: "POST",
      });
      return data;
    } catch (error) {
      return ApiErrors.handleErrors(error);
    }
  },

  async pdv() {
    try {
      const { data } = await axios({ url: `/proveedores_pdv/actual/`, method: "GET" });
      return data;
    } catch (error) {
      return ApiErrors.handleErrors(error);
    }
  },

  async get(opciones = {}) {
    const pagina = opciones.page ?? 0;
    const cantidad = opciones.rows ?? 5000;
    const sort_nombre = opciones.sortField ?? "id";
    const sort_orden = opciones.sortOrder ?? 1;
    const filtro = opciones.filters?.global?.value ?? "";
    const borrados = opciones.borrados ?? false;
    const proveedor_id = opciones.proveedor_id ?? 0;

    try {
      const { data } = await axios({
        url: `/proveedores_pdv/?pagina=${pagina}&cantidad=${cantidad}&sort_nombre=${sort_nombre}&sort_orden=${sort_orden}&filtro=${filtro}&borrados=${borrados}&proveedor_id=${proveedor_id}`,
        method: "GET",
      });
      return data;
    } catch (error) {
      return ApiErrors.handleErrors(error);
    }
  },

  async add(proveedorPDVNuevo) {
    try {
      const { data } = await axios({
        url: `/proveedores_pdv/`,
        data: proveedorPDVNuevo,
        method: "POST",
      });
      return data;
    } catch (error) {
      return ApiErrors.handleErrors(error);
    }
  },

  async nuevo_password_temporal(proveedorPDVId) {
    try {
      const { data } = await axios({
        url: `/proveedores_pdv/nuevo_password_temporal/${proveedorPDVId}`,
        method: "GET",
      });
      return data;
    } catch (error) {
      return ApiErrors.handleErrors(error);
    }
  },

  async update(proveedorPDVActualizado) {
    try {
      const { data } = await axios({
        url: `/proveedores_pdv/${proveedorPDVActualizado.id}`,
        data: proveedorPDVActualizado,
        method: "PUT",
      });
      return data;
    } catch (error) {
      return ApiErrors.handleErrors(error);
    }
  },

  async delete(proveedorPDVId) {
    try {
      await axios({ url: `/proveedores_pdv/${proveedorPDVId}`, method: "DELETE" });
    } catch (error) {
      return ApiErrors.handleErrors(error);
    }
  },
};
